import { Backdrop, CircularProgress, SxProps, Theme } from "@mui/material";

interface IOverlayLoadingSpinnerProps {
    sx?: SxProps<Theme>;
}

export const OverlayLoadingSpinner = ({ sx }: IOverlayLoadingSpinnerProps) => (
    <Backdrop
        open={true}
        sx={{
            position: "absolute",
            zIndex: 1,
            backgroundColor: "var(--mui-palette-whiteAlpha-700)",
            ...sx,
        }}
    >
        <CircularProgress size="64px" thickness={5} />
    </Backdrop>
);
